class ExportEvents {
    // eslint-disable-next-line class-methods-use-this
    setEventBus(componentName, id, scope) {
        if (!window[`${componentName}EventBus`]) {
            window[`${componentName}EventBus`] = {};
        }

        if (id) {
            window[`${componentName}EventBus`][id] = scope;
        } else {
            window[`${componentName}EventBus`] = scope;
        }
    }

    // eslint-disable-next-line class-methods-use-this
    deregisterEventBus(componentName, id) {
        if (id) {
            if (window[`${componentName}EventBus`] && window[`${componentName}EventBus`][id]) {
                delete window[`${componentName}EventBus`][id];
            }
        } else if (window[`${componentName}EventBus`]) {
            delete window[`${componentName}EventBus`];
        }
    }
}

export default new ExportEvents();
